function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import MeatballMenuIcon from '@bfly/icons/MeatballMenu';
import styled from 'astroturf';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Dropdown from './Dropdown';
import { useTheme } from './ThemeContext';
const messages = defineMessages({
  moreActions: {
    "id": "@bfly/ui:moreActions",
    "defaultMessage": "More Actions"
  }
}); // Use 'link' button styling but use non-link button color

const Toggle = /*#__PURE__*/styled(Dropdown.Toggle, null, {
  displayName: "Toggle",
  styles: require("./MeatballDropdownButton-Toggle.module.scss"),
  attrs: props => ({ ...props,
    theme: 'link',
    contextTheme: useTheme()
  }),
  vars: []
});
export default function MeatballDropdownButton({
  id,
  as,
  label,
  children,
  ...props
}) {
  const {
    formatMessage
  } = useIntl();
  return React.createElement(Dropdown, {
    alignRight: true,
    className: "d-flex"
  }, React.createElement(Toggle, _extends({
    id: id,
    as: as,
    "aria-label": label || formatMessage(messages.moreActions)
  }, props), React.createElement(MeatballMenuIcon, null)), React.createElement(Dropdown.Menu, {
    role: "menu"
  }, children));
}